import React from "react";
import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../../../../components/ui/sidebar";
import { useLanguage } from "../../../../context/LanguageContext";
import TeacherHeader from "./TeacherHeader";
import { AppSidebarTeacher } from "../../../../components/appSidebarTeacher";
import Footer from "../../../../components/Footer";

export default function TeacherRoot() {
  const { language } = useLanguage();

  return (
    <SidebarProvider>
      {language !== "ar" && <AppSidebarTeacher />}
      <main className="w-full flex flex-col">
        <TeacherHeader />
        <div className="p-5 flex-1">
          <Outlet />
        </div>
        <Footer />
      </main>
      {language === "ar" && <AppSidebarTeacher />}
    </SidebarProvider>
  );
}
